/* eslint-disable no-use-before-define */
import React from 'react'
import { fmt } from '../../twd'

const borderBottom0 = {
    borderBottom:0
}
const borderTop0 = {
    borderTop:0
}
const marginBottom0 = {
    marginBottom:0
}
export const Table = ({context}) => {
    return <React.Fragment>
    <div className="row vertical-offset-xs table-responsive trade-history-table-scroll"
    style={{
        margin: 0,
        background: '#ffffff',
        border: 'solid 1px #e4e4e4',
        minHeight: '575PX',
        maxHeight: '575px',
        overflowY: 'auto',
    }}>
    <table className="table table-summary trade-history-sticky-table" style={marginBottom0}>
    <thead>
    <tr style={borderBottom0}>
        <th className="text-center text-medium" colSpan="2" style={borderBottom0}>Trade activity</th>
        <th className="text-center text-medium" colSpan="3" style={borderBottom0}>Highest reported trade</th>
        <th className="text-center text-medium" colSpan="3" style={borderBottom0}>Lowest reported trade</th>
    </tr>
    <tr>
        <th>Date</th>
        <th className="text-right trade-history-summary-col-sep">Total trades</th>
        <th className="text-right">Price</th>
        <th className="text-right">Yield</th>
        <th className="text-right trade-history-summary-col-sep">Quantity</th>
        <th className="text-right">Price</th>
        <th className="text-right">Yield</th>
        <th className="text-right">Quantity</th>
    </tr>
    </thead>
    <tbody>{(context.trades || []).map( (r,i) => <SummaryRow key={`summary-${i}`} idx={i} {...r} />)}</tbody>
    </table>
    </div>

    <div className="row vertical-offset-xs text-right text-small">
    <div className="col-md-12">
        {context.hasEstimates ? <React.Fragment>* Total quantity traded may be greater due to 1MM+ trades<br/></React.Fragment> : null}
        Source: FINRA TRACE/MSRB
    </div>
    </div>
    </React.Fragment>
}

const SummaryRow = ({idx, tradeDate, totalTrades, highPrice, highYield, highQuantity, lowPrice, lowYield, lowQuantity, lowIsEstimate, highIsEstimate, details=[]} = {}) => {

    const [showDetails, setShowDetails] = React.useState(idx === 0)
    const toggleDetails = () => setShowDetails(!showDetails)

    const c ="text-right"
    return <React.Fragment>
        <tr key={`summary-${idx}`} className={ showDetails ? "text-medium" : ""}>
            <td className="trade-history-summary-col-sep">
                <button 
                    type="button"
                    className="btn-link"
                    aria-label={`toggle details for ${tradeDate}`}
                    onClick={toggleDetails}
                ><i
                    style={{color:'var(--primary-base-color)', fontSize:"large"}}
                    className="toggle-button-icon-open material-icons"
                    aria-hidden={true}
                >{ showDetails ? 'keyboard_arrow_down' : 'keyboard_arrow_right'}</i>
                {tradeDate}
                </button>
            </td>
            <td className={`${c} trade-history-summary-col-sep`}>{totalTrades}</td>
            <td className={c}>{fmt.price3(highPrice)}</td>
            <td className={c}>{fmt.ytw3(highYield)}</td>
            <td className={`${c} trade-history-summary-col-sep`}>{highIsEstimate ? '* 1,000' : fmt.qty(highQuantity)}</td>
            <td className={c}>{fmt.price3(lowPrice)}</td>
            <td className={c}>{fmt.ytw3(lowYield)}</td>
            <td className={c}>{lowIsEstimate ? '* 1,000' : fmt.qty(lowQuantity)}</td>
        </tr>

        <tr key={`summary-detail-${idx}`} style={{backgroundColor:'#ffffff', display: showDetails ? 'table-row' : 'none'}}>
            <td colSpan="8" style={{paddingLeft:'25px', backgroundColor: '#ffffff'}}>
            <Details tradeDate={tradeDate} details={details} />
            </td>
        </tr>

    </React.Fragment>
}

const Details = ({tradeDate, details=[]} = {}) => {
    return <React.Fragment>
        <table className="table table-striped trade-history-detail-table">
        <thead>
        <tr>
            <th colSpan="5" className="text-medium" style={borderBottom0}>Trade details for {tradeDate}</th>
        </tr>
        <tr>
            <th style={borderTop0}>Trade time</th>
            <th className="text-right" style={borderTop0}>Price</th>
            <th className="text-right" style={borderTop0}>Yield</th>
            <th className="text-right" style={borderTop0}>Quantity</th>
            <th style={borderTop0}>Trade Type (Special Notes)</th>
        </tr>
        </thead>
        <tbody>{ details.map((r,i) => <DetailRow key={`details-${i}`} idx={i} {...r} />) }</tbody>
        </table>
    </React.Fragment>
}

const DetailRow = ({idx, tradeDateTime, tradePrice, tradeYield, tradeQuantity, tradeType, tradeNotes, isEstimate }) => {
    return <React.Fragment>
        <tr key={`detail-row-${idx}`}>
            <td style={{ whiteSpace: 'nowrap', verticalAlign: 'top' }}>{fmt.ts(tradeDateTime)}</td>
            <td className="text-right" style={{verticalAlign:'top'}}>{fmt.price3(tradePrice)}</td>
            <td className="text-right" style={{verticalAlign:'top'}}>{fmt.ytw3(tradeYield)}</td>
            <td className="text-right" style={{verticalAlign:'top'}}>{isEstimate ? '* 1,000' : fmt.qty(tradeQuantity)}</td>
            <td style={{ verticalAlign: 'top' }}>{tradeType} {tradeNotes ? `(${tradeNotes})` : ''}</td>
        </tr>
    </React.Fragment>
}



// WEBPACK FOOTER //
// ./src/trade-history/summary-table/table.js